module.exports = __webpack_public_path__ + "static/img/coupon.79fea90f.png";